
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Terms of Service - Fly Local Boost</title>
        <meta name="description" content="Read the Terms of Service for Fly Local Boost. Learn about our service terms, user responsibilities, and platform usage guidelines." />
        <meta name="keywords" content="terms of service, user agreement, service terms, platform terms" />
        <link rel="canonical" href="https://fly-social.com/terms" />
      </Helmet>
      {/* Stripped header — sticky Fly logo only, no nav links. */}
      <div className="fixed top-0 left-0 right-0 z-50 px-6 lg:px-10 pt-6 pointer-events-none">
        <a href="/" className="inline-flex items-center pointer-events-auto" aria-label="Fly — Terms">
          <img
            src="/lovable-uploads/2e7bf5aa-9c7b-41ea-b64a-48b87f3dc01d.png"
            alt="Fly"
            className="h-16 md:h-20 drop-shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
          />
        </a>
      </div>
      
      <div className="container mx-auto px-4 pt-24 md:pt-32 pb-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
          
          <div className="prose prose-lg">
            <p className="text-gray-600">Last updated: May 15, 2025</p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Introduction</h2>
            <p>
              Welcome to Fly ("we," "our," or "us"). By accessing or using our services, you agree to be bound by these Terms of Service.
              Please read these terms carefully before using our platform.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. Definitions</h2>
            <p>
              "Service" refers to the Fly platform, which helps businesses manage and optimize their Google Business Profiles.
              "User," "you," and "your" refer to individuals or entities using our Service.
              "Content" includes text, images, data, and other materials you provide to us or generate through our Service.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. Account Registration</h2>
            <p>
              You must register for an account to use our Service. You agree to provide accurate and complete information when creating your account
              and to update such information to keep it accurate and current. You are responsible for maintaining the confidentiality of your account credentials
              and for all activities that occur under your account.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Service Access and Usage</h2>
            <p>
              Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, and revocable license to access and use our Service.
              You agree not to use our Service for any illegal or unauthorized purpose or in any way that could damage, disable, overburden, or impair our servers or networks.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Intellectual Property</h2>
            <p>
              Our Service and its original content, features, and functionality are owned by ZoomLocal Tech Private Limited and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
            
            <div className="my-8">
              <Link to="/" className="text-fly-purple hover:underline">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Footer compact />
    </div>
  );
};

export default Terms;
